import { configureStore } from '@reduxjs/toolkit'
import userReducer from './user';
import snackbarReducer from './snackbar';
export const store = configureStore({
    reducer: {
        user: userReducer,
        snackBar: snackbarReducer
    },
})